import { useMutation } from "@apollo/client";
import { notifications } from "@mantine/notifications";

import { UPDATE_USER } from "../gql/users";

export const useUser = () => {
  const [updateUserMutation] = useMutation(UPDATE_USER);

  const updateUser = async (
    options: Parameters<typeof updateUserMutation>[0]
  ) => {
    try {
      const req = await updateUserMutation(options);
      notifications.show({
        title: "User updated correctly",
        color: "green",
        message: "",
      });
      return req;
    } catch (e) {
      console.error(e);
      notifications.show({
        title: "Error while trying to update user",
        color: "red",
        message: "",
      });
    }
  };

  return {
    updateUser,
  };
};
